<template>
  <v-snackbar
    :timeout="4000"
    top right
    v-model="snackbar"
  >{{message}}<v-btn flat color="white" @click.native="snackbar = false">关闭</v-btn></v-snackbar>
</template>
<script>
export default {
  name: 'snack-bar',
  data: function () {
    return {
      snackbar: false,
      message: ''
    }
  },
  methods: {
    show (message) {
      if (this.snackbar) {
        this.snackbar = false
        this.$nextTick(() => {
          this.message = message
          this.snackbar = true
        })
      } else {
        this.message = message
        this.snackbar = true
      }
    }
  }
}
</script>
